<template>
	<div 
	class="form-group flex-grow-1" 
	:class="formGroupClass">
		
		<form-label 
		v-if="label" 
		:class="labelClass"
		:for="id"
		v-html="$sanitize(label)" />

		<div 
		class="input-group input-group-merge" 
		:class="{
			'in-group': inGroup,
			'clickable': clickable,
			'borderless': borderless
		}">

			<slot name="prepend"></slot>

			<div v-if="prependText"
			class="input-group-text">
				<small>{{prependText}}</small>
			</div>

			<div v-if="prependIcon"
			class="input-group-text">
				<i :class="'bi bi-'+prependIcon"></i>
			</div>

			<input 
			ref="input" 
			:id="id"
			:type="type" 
			:value="val" 
			v-bind="$attrs" 
			@input="input"
			class="form-control" 
			:class="{
				'is-invalid': $hasErrors(errors),
				'border-right-0': hasLoading
			}" />

			<slot name="append"></slot>

			<div v-if="appendText"
			class="input-group-text">
				<small>{{appendText}}</small>
			</div>

			<div v-if="appendIcon"
			class="input-group-text">
				<i :class="'fe fe-'+appendIcon"></i>
			</div>

			<div v-if="hasLoading"
			class="input-group-text">
				<loader 
				v-if="loading"
				:small="true" />
			</div>

		</div> <!-- /.input-group -->
		
		<form-errors 
		v-if="errors" 
		v-bind="{errors}" />
	    
	</div>
</template>

<script>

	import { mapState } from 'vuex'

	export default {
		props: {
			id: {
				type: String,
				default() {
					return `input-group-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			labelClass: {
				type: String,
				default: ''
			},

			borderless: {
				type: Boolean,
				default: false
			},

			inGroup: {
				type: Boolean,
				default: false
			},

			clickable: {
				type: Boolean,
				default: false
			},

			type: {
				type: String,
				default: 'text',
			},

			hasLoading: {
				type: Boolean,
				default: false,
			},

			loading: {
				type: Boolean,
				default: false,
			},

			errors: {
  				type: String,
 				default: "",
  			},
			
			value: [String, Number, Object],
			label: String,
			sublabel: String,
			prependIcon: String,
			prependText: String,
			appendIcon: String,
			appendText: String,
		},

		computed: {

			val() {
				return this.value
			}

		},

		methods: {

			focus() {
				this.$refs.input.focus()
			},

			input(event) {
				this.$emit('input', event.target.value)
			}
		},
	}

</script>